import { Authenticator } from 'services/AuthService.jsx';
import { BASE_API_URL } from 'services/ConfigService.jsx';

import Log from 'services/Log.jsx'



const PaymentAPI = {
  createBillingAgreement: function(params, callback) {
      Log.debug("[PaymentApi - createBillingAgreement] params: " + JSON.stringify(params));
      API.POST("/app/v1/billing", params, (response) => {
          callback(response);
      });
  },
};

const API = {
  GET: function(path, callback) {
    Log.debug("[PaymentService - GET] token: " + Authenticator.token);
    fetch(BASE_API_URL + path, {
      method: 'get',
      headers: {
       'Authorization': 'Bearer ' + Authenticator.token
      }
    })
    .then(function(response) {
      Log.debug(response);
      return response.json();
    })
    .then((response) => {
      if (response.success) {
        callback({success: true, data: response});
      } else {
        if (response.error && response.error.code) {
          if (response.error.code === 401) {
            Authenticator.signout(() => {
              window.location.href = "/";
            });
          }
        }
        callback({success: false, data: response});
      }
    })
    .catch((response) => {
      callback({success: false, data: response});
    });
  },
  POST: function(path, body, callback) {
    Log.debug("[PaymentService - POST] token: " + Authenticator.token);
    fetch(BASE_API_URL + path, {
      method: 'post',
      headers: {
       'Authorization': 'Bearer ' + Authenticator.token
      },
      body: JSON.stringify(body)
    })
    .then(function(response) {
        // Log.debug(JSON.stringify(response.json()));
      return response.json();
    })
    .then((response) => {
      if (response.success) {
        callback({success: true, data: response});
      } else {
        if (response.error && response.error.code) {
          if (response.error.code === 401) {
            Authenticator.signout(() => {
              window.location.href = "/";
            });
          }
        } else {
            callback({success: false, errors: response.errors});
        }
      }
    })
    .catch((response) => {
        Log.debug("[POST-ERROR] path: " + path + " request_body: " + JSON.stringify(body) + " response: " + JSON.stringify(response));
        Log.debug(response);
      callback({success: false, errors: ["Server Error"]});
    });
  },
  PUT: function(path, body, callback) {
    Log.debug("[PaymentService - PUT] token: " + Authenticator.token);
    fetch(BASE_API_URL + path, {
      method: 'put',
      headers: {
       'Authorization': 'Bearer ' + Authenticator.token
      },
      body: JSON.stringify(body)
    })
    .then(function(response) {
      return response.json();
    })
    .then((response) => {
      if (response.success) {
        callback({success: true, data: response});
      } else {
        if (response.error && response.error.code) {
          if (response.error.code === 401) {
            Authenticator.signout(() => {
              window.location.href = "/";
            });
          }
        } else {
            callback({success: false, errors: response.errors});
        }
      }
    })
    .catch((response) => {
      callback({success: false, errors: ["Server Error"]});
    });
  }
};

export { PaymentAPI }



// WEBPACK FOOTER //
// ./src/services/PaymentService.jsx